/* Native details semantics remain usable without JavaScript. */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.cb-mobile-menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('.cb-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
})();

(() => {
  let frame = 0;
  const syncHeader = () => {
    frame = 0;
    const header = document.getElementById('header-component');
    if (!header) return;
    const overlay = header.hasAttribute('data-cb-overlay');
    let stripHeight = 0;
    const group = document.getElementById('header-group');
    if (group) {
      for (const child of group.children) {
        if (child.contains(header)) break;
        stripHeight += child.getBoundingClientRect().height;
      }
    }
    header.toggleAttribute('data-cb-solid', window.scrollY > 8);
    document.documentElement.classList.toggle('carnaby-header-scrolled', window.scrollY > 8);
    header.toggleAttribute('data-cb-fixed', overlay && window.scrollY > Math.max(8, stripHeight));
  };
  const queue = () => { if (!frame) frame = requestAnimationFrame(syncHeader); };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('pageshow', queue);
  document.addEventListener('shopify:section:load', queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncHeader, { once: true });
  else syncHeader();
})();
